import type { LoanType } from '@/types';

export const LOAN_TYPE_LABELS: Record<LoanType, string> = {
  PERSONAL: 'Personal',
  BUSINESS: 'Business',
  MORTGAGE: 'Mortgage',
  AUTO: 'Auto',
  LINE_OF_CREDIT: 'Line of Credit',
};

export const LOAN_TYPE_DESCRIPTIONS: Record<LoanType, string> = {
  PERSONAL: 'Unsecured personal loan',
  BUSINESS: 'Business purpose loan',
  MORTGAGE: 'Secured against property',
  AUTO: 'Vehicle finance',
  LINE_OF_CREDIT: 'Draw down funds as needed up to a facility limit',
};

export function isLineOfCredit(loanType?: string | null): loanType is 'LINE_OF_CREDIT' {
  return loanType === 'LINE_OF_CREDIT';
}

export function getPrincipalLabel(loanType?: string | null): string {
  return isLineOfCredit(loanType) ? 'Facility Limit ($)' : 'Principal Amount ($)';
}

export function getPrincipalHelperText(loanType?: string | null): string | null {
  return isLineOfCredit(loanType)
    ? 'For a line of credit this amount is the approved limit. Actual drawn balance is managed in Tranches.'
    : null;
}

export function getFrequencyLabel(loanType?: string | null): string {
  return isLineOfCredit(loanType) ? 'Interest Billing Frequency' : 'Frequency';
}

export function getScheduleActionLabel(loanType?: string | null): string {
  return isLineOfCredit(loanType) ? 'Generate Interest Schedule' : 'Generate Schedule';
}
